import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentEntities } from "../PaymentEntities";


export interface PaymentListPageProps extends NSARouterMakerResult, PaymentProps
{ }

function PaymentListPage(props: PaymentListPageProps) 
{
    return (
        <PaymentLayout {...props}
            action={{
                title: '',
                description: 'A detailed list of all your payments, including their statuses.',
                menus: {}
            }}
            pages={{
                entity: PaymentEntities.Payment(props),
                list: {
                    ui: {}
                }
            }}
        >
            <></>
        </PaymentLayout >
    );
}

export default PaymentListPage;